export default "<div class=\"color-select-container dont-drag-me\">\n  <div class=\"color-picker\"></div>\n  <div class=\"color-prefixes\"></div>\n</div>\n";